import React, { useState, useEffect } from 'react';
import Modal from '../../../component/modal/Modal';
import Button from '../../../component/ui/Button';
import searchIcon from '../../../assets/image/search-status.svg';
import { product_list } from '../../../store/action/product';

const AddProduct = ({ isOpen, onClose, onAddProducts }) => {
	const [searchQuery, setSearchQuery] = useState('');
	const [selectedIds, setSelectedIds] = useState([]);
	const [availableProducts, setAvailableProducts] = useState([]);

	useEffect(() => {
		if (isOpen) {
			const param = searchQuery.trim() ? `search=${searchQuery.trim()}` : '';
			product_list(param)
				.then((res) => {
					console.log('product_list API Response in AddProduct:', res);
					const items =
						res?.data?.productWithStockCount ||
						res?.productWithStockCount ||
						res?.data?.products ||
						res?.products ||
						(Array.isArray(res?.data) ? res.data : []);

					if (items && items.length > 0) {
						const mapped = items.map((p) => ({
							id: p.product_id || p.id,
							name: p.product_name || p.name || '',
							UPC: p.product_code || p.code || p.UPC || '-',
							CATEGORY: p.category_name || p.org_packaging?.name || p.CATEGORY || '-',
							'AVAILABLE STOCK': `${p.stock_in_hand ?? 0} ${p.unit_name || 'units'}`,
							'UNIT PRICE': p.unit_price || p.sales_price || '0',
						}));
						setAvailableProducts(mapped);
					} else {
						setAvailableProducts([]);
					}
				})
				.catch((err) => {
					console.error('Error fetching products:', err);
					setAvailableProducts([]);
				});
		}
	}, [isOpen, searchQuery]);

	const filteredProducts = availableProducts.filter((p) => {
		if (!searchQuery.trim()) return true;
		const q = searchQuery.toLowerCase().trim();
		const nameMatch = p.name ? String(p.name).toLowerCase().includes(q) : false;
		const codeMatch = p.UPC ? String(p.UPC).toLowerCase().includes(q) : false;
		return nameMatch || codeMatch;
	});

	const handleToggleProduct = (id) => {
		setSelectedIds((prev) =>
			prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id]
		);
	};

	const handleReset = () => {
		setSearchQuery('');
		setSelectedIds([]);
	};

	const handleClose = () => {
		handleReset();
		if (onClose) onClose();
	};

	const handleAdd = () => {
		const selectedProducts = availableProducts.filter((item) => selectedIds.includes(item.id));
		if (onAddProducts) onAddProducts(selectedProducts);
		handleClose();
	};

	return (
		<div data-testid="product-list-add-products-modal">
			<Modal
				className="add-product-modal-wrapper"
				headerClassName="bg-white border-0 pb-0"
				isOpen={isOpen}
				onClose={handleClose}
				cancelButton={handleClose}
				secondaryText={`${selectedIds.length} of ${availableProducts.length} Selected`}
				title="Add Products"
			>
				<div className="add-product-modal-container">
					{/* Search Bar & Reset Row */}
					<div className="d-flex align-items-center gap-2 mb-1">
						<div className="position-relative flex-grow-1">
							<img
								src={searchIcon}
								alt="search"
								className="position-absolute top-50 start-0 translate-middle-y ms-3"
								style={{ width: '16px', height: '16px' }}
							/>
							<input
								type="text"
								className="form-control font-14 rounded-3 ps-5"
								placeholder="Search by product name and product code"
								value={searchQuery}
								data-testid="product-list-add-products-search-input"
								onChange={(e) => setSearchQuery(e.target.value)}
							/>
						</div>
						<button
							type="button"
							className="btn text-secondary font-14 fw-semibold p-0 ms-1"
							onClick={handleReset}
							data-testid="product-list-add-products-search-clear"
						>
							Reset
						</button>
					</div>

					{/* Products Items Card Scroll List */}
					<div className="add-product-items-list my-2" data-testid="product-list-add-products-list">
						{filteredProducts.length > 0 ? (
							filteredProducts.map((item) => {
								const isChecked = selectedIds.includes(item.id);
								return (
									<div
										key={item.id}
										data-testid={`product-list-add-products-item-${item.id}`}
										className="add-product-item-card d-flex align-items-center justify-content-between p-2 rounded-3 mb-2 cursor-pointer"
										onClick={() => handleToggleProduct(item.id)}
									>
										<div className="d-flex align-items-center gap-3">
											<input
												type="checkbox"
												className="form-check-input mt-0 cursor-pointer"
												checked={isChecked}
												readOnly
												data-testid={`product-list-add-products-checkbox-${item.id}`}
											/>
											<div>
												<p className="font-14 fw-bold mb-0 text-dark">{item.name}</p>
												<p className="font-12 text-muted mb-0">{item.UPC}</p>
											</div>
										</div>
									</div>
								);
							})
						) : (
							<div className="p-3 text-center text-muted font-14" data-testid="product-list-add-products-no-result-state">
								No products found
							</div>
						)}
					</div>

					{/* Footer Buttons Row */}
					<div className="d-flex justify-content-end gap-2 pt-2 border-top">
						<Button
							type="button"
							button="Cancel"
							className="btn-gray-cancel add-product-footer-btn px-4"
							onClick={handleClose}
							dataTestId="product-list-add-products-cancel-button"
						/>
						<Button
							type="button"
							button="Add"
							className="btn-primary add-product-footer-btn px-4"
							onClick={handleAdd}
							dataTestId="product-list-add-products-save-button"
						/>
					</div>
				</div>
			</Modal>
		</div>
	);
};

export default AddProduct;
